import { Util } from '@phdsoft/common';
import { SurfaceElement } from 'src/app/platform/busines-data/SectionElements/StructureElements/SurfaceElement';
import FeaUtils from '../FeaUtils';
import * as THREE from '@phdsoft/three';

export class FEAElement {
    label: string;
    surfaceDesign: THREE.Mesh;
    guid: string;
    regionId: string;
    regionName: string;
    feaValue: Array<any>;
    panelValue: Array<any>;
    min: number
    avg: number
    max: number
    byNode: boolean

    baseElement: SurfaceElement

    constructor(baseElement: SurfaceElement, feaVector: {}, byNode: boolean) {

        this.feaValue = new Array<any>();
        this.panelValue = new Array<any>();

        this.label = baseElement.Name
        this.guid = baseElement.Guid
        this.surfaceDesign = baseElement.SurfaceDesign
        this.regionId = baseElement.regionId
        this.regionName = baseElement.regionName
        this.baseElement = baseElement

        this.min = Number.POSITIVE_INFINITY;
        this.avg = 0;
        this.max = Number.NEGATIVE_INFINITY;

        this.byNode = byNode;
        const vectorIds = this.byNode ? baseElement.femNodeIds : baseElement.femElementIds;
        this.setFeaValues(feaVector, vectorIds)
    }

    public dispose(): void {
        const selectedObject = this.surfaceDesign.parent.getObjectByName(this.surfaceDesign.name);
        this.surfaceDesign.parent.remove(selectedObject);
        this.surfaceDesign.geometry.dispose();
    }
    public set Visibility(value) {
        this.surfaceDesign.visible = value;
    }
    public get Visibility(): boolean {
        return this.surfaceDesign.visible;
    }

    public get RealVisibility(): boolean {
      return this.baseElement.realVisibility;
    }

    private setFeaValues(feaVector, vectorIds: number[]) {
      let hasNonZeroValues = false;
      for (const id in vectorIds) {
        if (feaVector[id] !== 0 && !isNaN(feaVector[id])) {
          hasNonZeroValues = true;
          // console.debug('Found non-zero FEA value:', id, feaVector[id]);
          break;
        }
      }
      if (!hasNonZeroValues) {
        // console.debug('All FEA values are zero');
      }
      for (const id of vectorIds) { // todo: we are expecting to find values for each id
          let value = feaVector[id] // so what happens when we dont find any? the order is messed up!
          if (Util.isNullOrUndefined(value)) {
              value = NaN;
              this.feaValue.push(value);
              continue;
          }
          this.feaValue.push(value);
          this.max = Math.max(this.max, value);
          this.min = Math.min(this.min, value);
      }
      const validValues = this.feaValue.filter(num => !isNaN(num));
      const sum: number = validValues.reduce((acc: number, curr: number) => acc + curr, 0);
      this.avg = validValues.length > 0 ? sum / validValues.length : 0;

      // Apply the same formatting logic as backend to avoid floating point precision issues
      this.max = FeaUtils.formatFeaNumber(this.max);
      this.min = FeaUtils.formatFeaNumber(this.min);
      this.avg = FeaUtils.formatFeaNumber(this.avg);
  }
}
